import TripReport from './trip_report';

export type { TripReportArgs } from './trip_report';

export default TripReport;
